import {
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatDate, formatTime } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KTruckPreTripsTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no pre-trips to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching pre-trips found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "created_at"
		},

		sortDesc: {
			...KDataTable.options.props.sortDesc,
			default: true
		}
	},

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Date",
					value: "created_at"
				},
				{
					text: "Driver",
					value: "driver.user.name"
				},
				{
					text: "Notes",
					value: "notes"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.created_at": ( { item } ) => `${formatDate( item.created_at )} at ${formatTime( item.created_at )}`,

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "yardTruckPreTrip",
								params: {
									idTruck: item.idTruck,
									idPreTrip: item.id
								}
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
